import _ from 'lodash';
import C from '../constants';

const initialState = {
  questions: {
    hasreceiveddata: false,
    submittingnew: false,
    states: {}, // this will store per quote id if we're reading, editing or awaiting DB response
    data: {}, // this will contain firebase data,
    translated_questions: null
  },
};

export default function (currentstate, action) {
  let newstate;
  switch (action.type) {
    case C.RECEIVE_QUESTIONS_DATA:
      return Object.assign({}, currentstate, {
        hasreceiveddata: true,
        data: action.data,
      });
    case C.RECEIVE_TRANSLATED_QUESTIONS_DATA:
      return Object.assign({}, currentstate, {
        translated_questions: action.data,
      });
    case C.RECEIVE_QUESTION_DATA:
      return Object.assign({}, currentstate, {
        data: Object.assign({}, currentstate.data, {
          [action.uid]: action.data,
        })
      });
    case C.AWAIT_NEW_QUESTION_RESPONSE:
      return Object.assign({}, currentstate, {
        submittingnew: true,
      });
    case C.RECEIVE_NEW_QUESTION_RESPONSE:
      return Object.assign({}, currentstate, {
        submittingnew: false,
        newConceptModalOpen: false,
      });
    case C.START_QUESTION_EDIT:
      newstate = _.cloneDeep(currentstate);
      newstate.states[action.qid] = C.EDITING_QUESTION;
      return newstate;
    case C.FINISH_QUESTION_EDIT:
      newstate = _.cloneDeep(currentstate);
      delete newstate.states[action.qid];
      return newstate;
    case C.SUBMIT_QUESTION_EDIT:
      newstate = _.cloneDeep(currentstate);
      newstate.states[action.qid] = C.SUBMITTING_QUESTION;
      return newstate;
    case C.TOGGLE_NEW_QUESTION_MODAL:
      return Object.assign({}, currentstate, {
        newConceptModalOpen: !currentstate.newConceptModalOpen,
      });
    case C.START_RESPONSE_EDIT:
      newstate = _.cloneDeep(currentstate);
      newstate.states[action.qid] = `${C.START_RESPONSE_EDIT}_${action.rid}`;
      return newstate;
    case C.FINISH_RESPONSE_EDIT:
      newstate = _.cloneDeep(currentstate);
      delete newstate.states[action.qid];
      return newstate;
    case C.SUBMIT_RESPONSE_EDIT:
      newstate = _.cloneDeep(currentstate);
      newstate.states[action.qid] = C.SUBMITTING_RESPONSE;
      return newstate;
    case C.SHOULD_RELOAD_RESPONSES:
      newstate = _.cloneDeep(currentstate);
      newstate.states[action.qid] = C.SHOULD_RELOAD_RESPONSES;
      return newstate;
    case C.CLEAR_QUESTION_STATE:
      newstate = _.cloneDeep(currentstate);
      delete newstate.states[action.qid];
      return newstate;
    default: return currentstate || initialState.questions;
  }
}
